import { createFileRoute } from '@tanstack/react-router';
import { TransactionalMetricsRoute } from '@/pages/workspaces/transactional/message/overview/metrics/routing';

function TransactionalMetricsRouteComponent() {
  const { transactionalMessageId } = Route.useParams();
  return <TransactionalMetricsRoute transactionalMessageId={transactionalMessageId} />;
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/transactional_/$transactionalMessageId/overview/metrics',
)({
  component: TransactionalMetricsRouteComponent,
});
